export default __webpack_public_path__ + "static/media/wsj.c98c1c11.png";